
import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Header } from './Header';

import {Footer} from './Footer';
import { CommonGet } from '../utils/CommonFetch';
import $ from "jquery";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { CommonHeader } from '../components/CommonHeader/CommonHeader'
const menuItems = [

    {
        id: 100,
        label: 'Master Data',
        icon: 'fas fa-database',
        className: 'bold',
        //expanded: 'false',
        items: [
            {
                id: 1,
                label: 'Branch',
                icon: 'fas fa-file',
                link: '/masterdata/branch/Index',
                className: 'active',
            },
            {
                id: 2,
                label: 'Terminal Maintenance',
                icon: 'fas fa-file',
                link: '/mobilebanking/terminalmaintenance/index',
            }

        ]
    },
    {
        id: 200,
        label: 'Mobile Management',
        icon: 'fas fa-mobile',

        items: [
            {
                id: 1,
                label: 'Mobile Vendors',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilevendors/Index',

            },
            {
                id: 2,
                label: 'Mobile Manufacturer',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilemanufacturers/index',
            },
            {
                id: 3,
                label: 'Mobile Model',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilemodels/index',
            },
            {
                id: 4,
                label: 'Mobile',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobile/index',
            }

        ]
    },
    {
        id: 825,
        label: 'SIM Management',
        icon: 'fas fa-microchip',

        items: [
            {
                id: 1,
                label: 'Network Operator',
                icon: 'fas fa-file',
                link: '/mobilebanking/networkoperator/Index',
            },
            {
                id: 2,
                label: 'SIM',
                icon: 'fas fa-file',
                link: '/mobilebanking/sim/index',
            }

        ]
    },
    {
        id: 400,
        label: 'Mobile Banking',
        icon: 'fas fa-credit-card',

        items: [
            {
                id: 1,
                label: 'Mobile Package Creation',
                icon: 'fas fa-file',
                link: '/mobilebanking/mobilepackage/index',
            },
            {
                id: 2,
                label: 'Mobile Package Maintenance',
                icon: 'fas fa-file',
                link: '/mobilebanking/PackageUserMaintain/Index',
            },
            {
                id: 3,
                label: 'Teller Request List',
                icon: 'fas fa-file',
                link: '/mobilebanking/tellerrequestlist/index',
            },
            {
                id: 4,
                label: 'Transaction Search',
                icon: 'fas fa-file',
                link: '/mobilebanking/transactionsearch/index',
            },

        ]
    },
    {
        id: 500,
        label: 'Maintain Roles',
        icon: 'fas fa-address-card',

        items: [
            {
                id: 1,
                label: 'Maintain User Roles',
                icon: 'fas fa-file',
                link: '/mobilebanking/rolemaintain/index',
            }
        ]
    },
    {
        id: 600,
        label: 'Admin',
        icon: 'fas fa-address-card',

        items: [
            {
                id: 1,
                label: 'Create User',
                icon: 'fas fa-file',
                link: '/admin/createuser',
            },
            {
                id: 2,
                label: 'Edit User',
                icon: 'fas fa-file',
                link: '/admin/edituser/index',
            }

        ]
    }
];

export class Layout extends Component {
    displayName = Layout.name

    jqueryScripts = () => {
        $(document).ready(function () {
            $('#example').DataTable({
                "order": [[0, "desc"]]
            });
        });
    }
    componentWillMount() {
        this.jqueryScripts();
    }



    render() {

        return (
       
            <div>
                {this.props.children}
                <div>
                    <Footer />
                </div>
            </div>
           
        );
    }
}
